/** @format */

import {
	Component,
	ComponentRef,
	Injector,
	OnInit,
	ViewChild,
	ViewContainerRef,
	ɵcreateInjector as createInjector
} from '@angular/core';
import {
	DynamicMyAccountTemplateModulesEnum,
	LoginAppPathsEnum
} from '@my-account/data-access/enums';

import { HttpService } from '@shared/data-access/services';

@Component({
	selector: 'my-account-complete-profile-container',
	templateUrl: './complete-profile-container.component.html',
	styleUrl: './complete-profile-container.component.scss',
	standalone: false
})
export class CompleteProfileContainerComponent implements OnInit {
	/**
	 * @description
	 * Template outlet for dynamically loaded templates
	 */
	@ViewChild('templateOutlet', { read: ViewContainerRef, static: false })
	public templateOutlet: ViewContainerRef;

	private dynamicComponentRef: ComponentRef<any>;

	private dynamicTemplateToLoad = DynamicMyAccountTemplateModulesEnum.COMPLETEPROFILE;
	private urlPath = this.httpService.getUrlPath();

	constructor(
		private httpService: HttpService,
		private injector: Injector
	) {}

	ngOnInit(): void {
		if (this.urlPath === LoginAppPathsEnum.COMPLETEPROFILE) {
			this.dynamicTemplateToLoad = DynamicMyAccountTemplateModulesEnum.COMPLETEPROFILE;
		}

		// Load the dynamic template
		this.loadDynamicModule(this.dynamicTemplateToLoad);
	}

	/**
	 * @description
	 * Loads a dynamic module by name
	 */
	private loadDynamicModule(componentId: string): void {
		// Check the component ID
		if (componentId === DynamicMyAccountTemplateModulesEnum.COMPLETEPROFILE) {
			import(
				'libs/my-account/complete-profile/templates/src/lib/complete-profile.module'
			).then(({ CompleteProfileModule }) => {
				// Pass the imported component module in to create the component instance
				this.createDynamicComponent(CompleteProfileModule);
			});
		} else {
			throw new Error(
				`Unknown component ID: ${componentId}.  Unable to render any lazy components.`
			);
		}
	}

	/**
	 * @description
	 * Creates a dynamic component for a given component module
	 */
	private createDynamicComponent(componentModuleRef: any) {
		// Create the injector
		const injector = createInjector(componentModuleRef, this.injector);

		// Get the component module from the injector
		const componentModule = injector.get<any>(componentModuleRef);

		// Resolve the component factory
		const componentFactory = componentModule.resolveComponentFactory();

		// Create the template component and get its reference
		this.dynamicComponentRef = this.templateOutlet.createComponent(componentFactory);

		// Start change detection
		this.dynamicComponentRef.changeDetectorRef.detectChanges();
	}
}
